var amdi18n={"__root":{"get_options_started":"Get options started","get_options_succeeded":"Get options succeeded","get_options_failed":"Get options failed","session_expired":"Session expired","select_option_started":"Select option started","invalid_activation_url":"Invalid activation url: ","select_option_succeeded":"Select option succeeded","select_option_failed":"Select option failed","cancel_select_option_started":"Cancel option selection started","cancel_select_option_succeeded":"Cancel option selection succeeded","cancel_select_option_failed":"Cancel option selection failed","invalid_redirect_url":"Invalid redirect url: ","finish_authentication":"Finish authentication","finish_authentication_succeeded":"Finish authentication succeeded","finish_authentication_failed":"Finish authentication failed"},"__de":{"session_expired":"Sitzung ist abgelaufen"}};amdi18n.init=function(language){
		// get the default language
		if(!language){
			if(window._i18n && window._i18n.locale){
				language = window._i18n.locale;
			}else if(document.documentElement.lang){
				language = document.documentElement.lang;
			}else{
				language = 'root';
			}
		}
		var target = this['__' + language] || this.__root;

		// copy definition to root level
		if (target) {
			for (var name in target) {
				this[name] = target[name];
			}
		}

		// fallback to root
		for(var name in this.__root){
			if(typeof this[name] === 'undefined'){
				this[name] = this.__root[name];
			}
		}
	};amdi18n.init();module.exports=amdi18n;


//////////////////
// WEBPACK FOOTER
// ./node_modules/amdi18n-loader!./src/main/web/js/app/service/nls/OptionsManager_strings.js
// module id = 275
// module chunks = 4